module.exports = __webpack_public_path__ + "img/Vector.7b3d1fe1.svg";